import React from "react";

import { Autocomplete, TextField } from "@mui/material";
import Api from "../../Api/Api";

export default function ListEditInput(props) {
  const { id, field, value, api, listSuggestions } = props;

  const [inputValue, setInputValue] = React.useState(value || "");

  return (
    <Autocomplete
      freeSolo
      options={listSuggestions}
      value={inputValue}
      inputValue={inputValue}
      onInputChange={(event, newInputValue) => {
        setInputValue(newInputValue);

        api.setEditCellValue({
          id,
          field,
          value: newInputValue,
        });
      }}
      onChange={(event, newValue) => {
        const finalValue = newValue || "";

        setInputValue(finalValue);

        api.setEditCellValue({
          id,
          field,
          value: finalValue,
        });
      }}
      renderInput={(params) => (
        <TextField {...params} variant="standard" fullWidth />
      )}
    />
  );
}
